module.exports = __webpack_public_path__ + "static/media/au-nuget.68f45f66.png";